export default __webpack_public_path__ + "static/media/coach.ec001b20.png";